module.exports = __webpack_public_path__ + "static/media/6.fc14ce95.jpg";